// extracted by mini-css-extract-plugin
module.exports = {"AnnouncementBar":"AnnouncementBar_AnnouncementBar__1_J1z","Hide":"AnnouncementBar_Hide__2t0w7","Cross":"AnnouncementBar_Cross__39TqU"};